import { TextField, FormControl, Grid, Typography, Box } from '@mui/material';
import Styles from '../Styles/SearchMapsStyles';
import { useRef, useState } from 'react';
import { debounceDelay } from '../../../settings/appConfig';
import { genericTitle } from '../../../assets/styles/appStyles';

export default function AssociationsSearch({
  onSearchChanged,
}: Readonly<{
  onSearchChanged: (searchText?: string, stateId?: string) => void;
}>) {
  const [associationSearchText, setAssociationSearchText] = useState<string>('');
  const associationTimeoutId = useRef<any>(null);
  const handleChangeAssociationSearchText = (value: string) => {
    setAssociationSearchText(value);
    if (associationTimeoutId.current) {
      clearTimeout(associationTimeoutId.current);
    }
    associationTimeoutId.current = setTimeout(() => {
      onSearchChanged(value);
    }, debounceDelay);
  };

  return (
    <Grid container mt={2} sx={Styles.greyCard}>
      <Grid px={2} container justifyContent={'space-between'} alignItems="center">
        <Typography align="left" sx={genericTitle}>
          Search Associations
        </Typography>
      </Grid>
      <Grid px={2} mb={2} container justifyContent={'space-between'} alignItems="center">
        <Grid item xs={12} md={6} lg={5}>
          <Box>
            <FormControl fullWidth>
              <TextField
                id="search-Text"
                value={associationSearchText}
                label={'Search Text'}
                variant="outlined"
                onChange={(
                  e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
                ) => handleChangeAssociationSearchText(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
